import { Action } from '@ngrx/store';

import { RequestPayload } from '../../shared/common/models/request-payload';
import { SearchResponseInterface } from '../../shared/common/interfaces/search-response.interface';
import { Supplier } from '../model';


/**
 * Start a Fetch for Supplier using the given request payload
 */
export const FETCH_MULTI = '[SUPPLIER] Fetch Multi';
export class FetchMultiAction implements Action {
  readonly type = FETCH_MULTI;


  constructor(public payload: {
    queryConfig?: RequestPayload;
    count?: number;
    offset?: number;
    customFields?: string[];
  }) {}
}

/**
 * Fetch for multiple Supplier succeeded, payload contains result-list
 */
export const FETCH_MULTI_SUCCEEDED = '[SUPPLIER] Fetch Multi Succeeded';
export class FetchMultiSucceededAction implements Action {
  readonly type = FETCH_MULTI_SUCCEEDED;


  constructor(public payload: SearchResponseInterface<Supplier>) {}
}

/**
 * Fetch for multiple Supplier failed, payload may contain additional informations
 */
export const FETCH_MULTI_FAILED = '[SUPPLIER] Fetch Multi Failed';
export class FetchMultiFailedAction implements Action {
  readonly type = FETCH_MULTI_FAILED;


  constructor(public payload: any) {}
}

/**
 * Start a Fetch for a single Supplier (with more details)
 */
export const FETCH_SINGLE = '[SUPPLIER] Fetch Single';
export class FetchSingleAction implements Action {
  readonly type = FETCH_SINGLE;


  constructor(public payload: {
    uuid: string;
    customFields?: string[];
  }) {}
}

/**
 * Fetch for a single Supplier succeeded, payload contains result
 */
export const FETCH_SINGLE_SUCCEEDED = '[SUPPLIER] Fetch Single Succeeded';
export class FetchSingleSucceededAction implements Action {
  readonly type = FETCH_SINGLE_SUCCEEDED;


  constructor(public payload: any) {}
}

/**
 * Fetch for a single Supplier failed, payload may contain additional informations
 */
export const FETCH_SINGLE_FAILED = '[SUPPLIER] Fetch Single Failed';
export class FetchSingleFailedAction implements Action {
  readonly type = FETCH_SINGLE_FAILED;


  constructor(public payload: any) {}
}

/**
 * Fetch for a single Supplier summary succeeded, payload contains result
 */
export const FETCH_SINGLE_SUMMARY_SUCCEEDED = '[SUPPLIER] Fetch Single Summary Succeeded';
export class FetchSingleSummarySucceededAction implements Action {
  readonly type = FETCH_SINGLE_SUMMARY_SUCCEEDED;

  constructor(public payload: any) {}
}

/**
 * Fetch for a single Supplier summary failed, payload may contain additional informations
 */
export const FETCH_SINGLE_SUMMARY_FAILED = '[SUPPLIER] Fetch Single Summary Failed';
export class FetchSingleSummaryFailedAction implements Action {
  readonly type = FETCH_SINGLE_SUMMARY_FAILED;


  constructor(public payload: any) {}
}

export const FETCH_HAS_LEADS = '[SUPPLIER] Fetch Has Leads';
export class FetchHasLeadsAction implements Action {
  readonly type = FETCH_HAS_LEADS;


  constructor(public payload: string) {}
}

/**
 * Fetch for a single Supplier succeeded, payload contains result
 */
export const FETCH_HAS_LEADS_SUCCEEDED = '[SUPPLIER] Fetch Has Leads Succeeded';
export class FetchHasLeadsSucceededAction implements Action {
  readonly type = FETCH_HAS_LEADS_SUCCEEDED;


  constructor(public payload: any) {}
}

/**
 * Fetch for a single Supplier failed, payload may contain additional informations
 */
export const FETCH_HAS_LEADS_FAILED = '[SUPPLIER] Fetch Has Leads Failed';
export class FetchHasLeadsFailedAction implements Action {
  readonly type = FETCH_HAS_LEADS_FAILED;


  constructor(public payload: any) {}
}

/**
 * Set the currently selected Supplier
 */
export const SELECT_ITEM = '[SUPPLIER] Select Item';
export class SelectItemAction implements Action {
  readonly type = SELECT_ITEM;


  constructor(public payload: string) {}
}

export const UPDATE_TEMP_ORDERING_VALUE = '[SUPPLIER] Update temp ordering value';
export class UpdateTempOrderingValueAction implements Action {
  readonly type = UPDATE_TEMP_ORDERING_VALUE;


  constructor(public payload: string[]) {}
}

export const CLEAR_SUPPLIER_SEARCHRESULTS = '[SUPPLIER] Clear all searchResults in supplier state';
export class ClearSupplierSearchResultsAction implements Action {
  readonly type = CLEAR_SUPPLIER_SEARCHRESULTS;
}

export type Actions = FetchMultiAction
  | FetchMultiSucceededAction
  | FetchMultiFailedAction
  | FetchSingleAction
  | FetchSingleSucceededAction
  | FetchSingleFailedAction
  | FetchSingleSummarySucceededAction
  | FetchSingleSummaryFailedAction
  | FetchHasLeadsAction
  | FetchHasLeadsSucceededAction
  | FetchHasLeadsFailedAction
  | SelectItemAction
  | UpdateTempOrderingValueAction
  | ClearSupplierSearchResultsAction;
